<template>
  <Flex items-center justify-start gap-1 class="py-1 text-xs text-gray-600">
    <IconSolid icon="fa-house" @click="goTo('home')" class="cursor-pointer hover:text-primary-700" />
    <span>/</span>
    <Flex gap-1 center v-for="(item, index) in items" :key="index" class="cursor-pointer hover:text-primary-700">
      <span v-if="item?.title" @click="goTo(item.name)" :class="{ 'font-bold': index >= items.length - 1 }">
        {{ item.title }}
      </span>
      <span v-if="index < items.length - 1">/</span>
    </Flex>
  </Flex>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const items = computed(() => route.meta.breadcrumb || [])

const goTo = (name) => {
  if (!name) {
    return
  }

  router.push({ name })
}
</script>
